var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 11.85C20.2638 11.1997 19.9499 10.3645 19.9501 9.5H17.3751V19.8333C17.3553 20.3925 17.1192 20.9222 16.7166 21.3108C16.314 21.6994 15.7763 21.9166 15.2168 21.9167C14.0335 21.9167 13.0501 20.95 13.0501 19.75C13.0501 18.3167 14.4335 17.2417 15.8585 17.6833V15.05C12.9835 14.6667 10.4668 16.9 10.4668 19.75C10.4668 22.525 12.7668 24.5 15.2085 24.5C17.8251 24.5 19.9501 22.375 19.9501 19.75V14.5083C20.9943 15.2582 22.2479 15.6605 23.5335 15.6583V13.0833C23.5335 13.0833 21.9668 13.1583 20.8335 11.85Z",
    fill: "#8E8E8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9232,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9232,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d76e1a87b3dd19a8cead16cafbd2ed30.svg";
export { ForwardRef as ReactComponent };